import React, { useEffect, useState, useContext } from "react";
import { Toolbar, TextField } from "@mui/material";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { PaginationComponent } from "../../Components/PaginationComponent";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import APIServices from "../../services/APIServices";
import apiconfig from "../../config/config";
import { EnvironmentContext } from "../../EnvironmentContext";
import { setAccessToken, setAllUserDetails } from "../../Redux/Actions";
import { useNavigate } from "react-router-dom";
import { setTotalOrganisersCount, setTotalTravellersCount, setTotalTravellersOrganisersCount } from "../../Redux/Actions";

function Customer() {
  const { environment } = useContext(EnvironmentContext);
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.accessToken);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [hasNextPage, setHasNextPage] = useState(true);

  const allUsers = useSelector((state) => state.allUserDetails);
  const allTravellersCount = useSelector((state) => state.totalTravellersCount)
  const allOrganisersCount = useSelector((state) => state.totalOrganiserCount)
  const allTravellersAndOrganisers = useSelector((state) => state.totalTravellersOrganser)

  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [noResults, setNoResults] = useState(false);


  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    const tokenLocal = JSON.parse(localStorage.getItem("token"));

    if (!accessToken && tokenLocal) {
      dispatch(setAccessToken(tokenLocal));
      APIServices.setAuthToken(tokenLocal);
    } else if (!accessToken && !tokenLocal) {
      navigate("/login");
    }

    if (accessToken || tokenLocal) {
      const tokenToUse = accessToken || tokenLocal;
      APIServices.setAuthToken(tokenToUse);
      setIsLoading(true);

      const url =
        environment === "Production"
          ? apiconfig.production.apiBaseUrl
          : apiconfig.develpoment.apiBaseUrl;

      APIServices.setApiBaseUrl(url);
      fetchUsers(paginationModel.page, paginationModel.pageSize);
    }
  }, [dispatch, environment, accessToken, navigate, paginationModel]);

  const fetchUsers = (page, limit) => {
    APIServices.allUsersProfile(page + 1, limit)
      .then((response) => {
        setIsLoading(false);
        dispatch(setAllUserDetails(response?.data?.Users));
        dispatch(setTotalTravellersCount(response.data.totalUserCount))
        dispatch(setTotalTravellersOrganisersCount(response.data.totalUserAndOrganiserCount))
        dispatch(setTotalOrganisersCount(response.data.totalOrganiserCount))
        setHasNextPage(response?.data?.Users?.length === limit);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error while fetching all users: ", err);
      });
  };

  const handlePaginationModelChange = (newModel) => setPaginationModel(newModel);
  const columns = [
    {
      field: "profile_id",
      headerName: "Profile ID",
      width: 150,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
      renderCell: (params) => (
        <Link
          to={`/customer/${params.value}`}
          style={{ color: "blue", fontFamily: "Poppins" }}
        >
          {params.value}
        </Link>
      ),
    },
    {
      field: "dateJoined",
      headerName: "Date joined",
      width: 150,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "firstName",
      headerName: "First name",
      width: 150,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "lastName",
      headerName: "Last name",
      width: 150,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "userType",
      headerName: "User status ",
      width: 150,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "email",
      headerName: "Email ID",
      width: 250,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
  ];

  const rows = (searchQuery && searchResults.length > 0 ? searchResults : allUsers)?.map((item, index) => ({
    id: index,
    ids: item?._id,
    profile_id: item?.profile_id,
    dateJoined: item?.signup_date[0],
    firstName: item?.firstName,
    lastName: item?.lastName,
    userType: item?.user_type === 'organiser' ? "Organiser" : item?.user_type === 'admin' ? "ADMIN" : "User",
    email: item?.email,
  }));

  const handleSearchChange = (e) => {
    const newQuery = e.target.value;
    setSearchQuery(newQuery);
    setNoResults(false)

    if (newQuery.length === 0) {
      setSearchResults([]);
      return;
    }

    if (newQuery.length >= 4) {
      APIServices.getUserSeachQuery(newQuery)
        .then((response) => {
          const results = response.data.Results;
          setSearchResults(results);
          console.log('search res:', results)
          setNoResults(results.length === 0);
        })
        .catch((err) => {
          console.log("Error while searching for users:", err);
        });
    }

  }

  return (
    <>

      <div className="customer-cont">
        <div className="travellers-org-container">
          <div className="travellers-org">
            <PeopleAltOutlinedIcon
              style={{
                width: "33px",
                height: "33px",
                color: "#059669",
              }}
            />
            <div className="travells-cont">
              <p className="total-users-para">Total Users</p>
              <h3 className="total-users-heading">{allTravellersAndOrganisers}</h3>
            </div>
          </div>

          <div className="travellers-org">
            <PeopleAltOutlinedIcon
              style={{
                width: "33px",
                height: "33px",
                color: "#059669",
              }}
            />
            <div className="travells-cont">
              <p className="total-users-para">Travellers</p>
              <h3 className="total-users-heading">
                {allTravellersCount}
              </h3>
            </div>
          </div>

          <div className="travellers-org">
            <PeopleAltOutlinedIcon
              style={{
                width: "33px",
                height: "33px",
                color: "#059669",
              }}
            />
            <div className="travells-cont">
              <p className="total-users-para">Trip organisers</p>
              <h3 className="total-users-heading">
                {allOrganisersCount}
              </h3>
            </div>
          </div>
        </div>

        <div>
          <p className="fullname-cell ">Search for users by profile Id, first name, last name, user status, email</p>
          <TextField size='small'
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
            className="input-fields-date"
            inputProps={{
              style: {
                fontSize: 12,
                fontFamily: "Poppins",
              },
            }}
          />
          {noResults && <p className="fullname-cell" style={{ color: "red", marginTop: '5px', fontSize: '13px' }}>No users found</p>}
        </div>

        <Toolbar />

        <main style={{ flexGrow: 1 }}>
          <PaginationComponent
            columns={columns}
            rows={rows}
            isLoading={isLoading}
            paginationModel={paginationModel}
            paginationMeta={{ hasNextPage }}
            onPaginationModelChange={handlePaginationModelChange}
            rowCount={allTravellersAndOrganisers}
          />
        </main>
      </div>
    </>
  );
}

export default Customer;
